import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, Validators } from '@angular/forms';

import { DeleteUserReasonEnum } from '@sifca-monorepo/ecommerce-generator';
import { MobileAuthService, MobileThemeService, ToasterService } from '@sifca-monorepo/clients';

@Component({
  template: '',
})
export class MobileDeleteAccountComponent {
  isSubmitting = false;
  isPasswordHidden = true;
  isDark$ = this.themeService.darkMode$;

  readonly reasons = [
    { value: DeleteUserReasonEnum.LACK_OF_CONTENT, label: 'DELETE_ACCOUNT.REASON_LACK_CONTENT' },
    { value: DeleteUserReasonEnum.SOMETHING_IS_BROKEN, label: 'DELETE_ACCOUNT.REASON_BROKEN' },
    { value: DeleteUserReasonEnum.SIZE_AND_COMPATIBILITY, label: 'DELETE_ACCOUNT.REASON_COMPATIBILITY' },
  ];

  readonly deleteForm = this.formBuilder.group({
    password: ['', Validators.required],
    reason: [null, Validators.required],
    description: [''],
  });

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private authService: MobileAuthService,
    private toasterService: ToasterService,
    private themeService: MobileThemeService,
    private alertController: AlertController,
  ) {}

  async submitDelete(): Promise<void> {
    if (this.deleteForm.invalid || this.isSubmitting) {
      this.deleteForm.markAllAsTouched();
      return;
    }

    const alert = await this.alertController.create({
      header: this.translate.instant('DELETE_ACCOUNT.CONFIRM_TITLE'),
      message: this.translate.instant('DELETE_ACCOUNT.CONFIRM_MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('CANCEL'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('DELETE_ACCOUNT.DELETE_BUTTON'),
          role: 'destructive',
          handler: () => this.proceedWithDelete(),
        },
      ],
    });

    await alert.present();
  }

  private proceedWithDelete(): void {
    this.isSubmitting = true;
    const { password, reason, description } = this.deleteForm.value;

    this.authService
      .deleteUser({
        password,
        reason,
        description,
      })
      .subscribe({
        next: (res) => {
          this.isSubmitting = false;
          if (res?.data?.deleteUser?.success) {
            this.toasterService.success(this.translate.instant('DELETE_ACCOUNT.SUCCESS'));
            this.clearSessionAndRedirect();
            return;
          }
          this.toasterService.error(this.translate.instant('DELETE_ACCOUNT.ERROR'));
        },
        error: () => {
          this.isSubmitting = false;
          this.toasterService.error(this.translate.instant('DELETE_ACCOUNT.ERROR'));
        },
      });
  }

  private clearSessionAndRedirect(): void {
    this.authService.authenticated$ = false;
    this.authService.currentUser$ = null;
    localStorage.removeItem('elvkwdigttoken');
    localStorage.removeItem('userId');
    localStorage.removeItem('currentUserId');
    localStorage.removeItem('elevkusr');
    localStorage.setItem('elvkwdigtauth', 'false');
    this.router.navigateByUrl('/auth/login', { replaceUrl: true });
  }
}
